import "./videoBackground.css";
import VideoBG from "../../assets/video/back-v3.mp4";

const BackgroundVideo = () => {
  return (
    <div className="video-background">
      <video autoPlay loop muted playsInline className="video">
        <source src={VideoBG} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default BackgroundVideo;
